import { AuthHeader } from '../_models/headers';


import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ResultData } from '../_models/ResultData';
import { AuthService } from './auth.service';
import { DataUtilService } from './data-util.service';
import { HeaderService } from './header.service';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  aHeader = undefined



  constructor(
    private http: HttpClient,
    private dataUtilService:DataUtilService,private tss:AuthService, private headerService:HeaderService) {this.aHeader = new AuthHeader(tss) }
    getCountriesAdmin() {
      return this.http.get<any>(`${environment.apiUrl}/country/index`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
        let myData=[]
        if(this.dataUtilService.isGoodResponse(data)){
          myData= this.dataUtilService.myData(data)
        }
        return myData
      }))
    }

    getCountriesIdAndName() {
      return this.http.get<any>(`${environment.apiUrl}/country/indexIdAndName`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
        let myData=[]
        if(this.dataUtilService.isGoodResponse(data)){
          myData= this.dataUtilService.myData(data)
        }
        return myData
      }))
    }
    getCountriesNotInEducationSystem(id:number) {
      return this.http.get<any>(`${environment.apiUrl}/country/listNotInEducation/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
        let myData=[]
        if(this.dataUtilService.isGoodResponse(data)){
          myData= this.dataUtilService.myData(data)
        }
        return myData
      }))
    }
  getCountryInfoByLevel(levelId: number):Observable<ResultData> {
    return this.http.get<ResultData>(`${environment.apiUrl}/level/country/${levelId}`,{headers:this.headerService.bearerJsonHeaders()})
      }

  getCountryInfo(userId: number) {
    return this.http.get<any>(`${environment.apiUrl}/subscription/apicountryinfo/${userId}`,this.aHeader.bearerJsonHeaders).pipe(map(
      xx=>{
        if(this.dataUtilService.isGoodResponse(xx)){
          return this.dataUtilService.myData(xx)
        }else{
          return {}
        }
      }))
      }

  getLevelIdAndNameByCurriculum(countryId: number) {
    return this.http.get<any>(`${environment.apiUrl}/level/getlevelsbycountry/${countryId}`,this.aHeader.openJsonHeaders).pipe(map(data => {

      if(this.dataUtilService.isGoodResponse(data)){
        return this.dataUtilService.myData(data)
      }else{
        return {}
      }
    }))
  }
  getCountries() {
    return this.http.get<any>(`${environment.apiUrl}/country/angularlist`,this.aHeader.openJsonHeaders).pipe(map(data => {
      let myData=[]
      if(this.dataUtilService.isGoodResponse(data)){
        myData= this.dataUtilService.myData(data)
      }

      return myData
    }))
  }

}
